var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00033 1.66671C3.30997 1.66671 2.75033 2.22635 2.75033 2.91671C2.75033 3.60706 3.30997 4.16671 4.00033 4.16671C4.69068 4.16671 5.25033 3.60706 5.25033 2.91671C5.25033 2.22635 4.69068 1.66671 4.00033 1.66671ZM1.91699 2.91671C1.91699 1.76611 2.84973 0.833374 4.00033 0.833374C5.15092 0.833374 6.08366 1.76611 6.08366 2.91671C6.08366 4.0673 5.15092 5.00004 4.00033 5.00004C2.84973 5.00004 1.91699 4.0673 1.91699 2.91671Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75033 6.66671C2.05997 6.66671 1.50033 7.22635 1.50033 7.91671V8.75004C1.50033 8.98016 1.31378 9.16671 1.08366 9.16671C0.85354 9.16671 0.666992 8.98016 0.666992 8.75004V7.91671C0.666992 6.76611 1.59973 5.83337 2.75033 5.83337H5.25033C6.40092 5.83337 7.33366 6.76611 7.33366 7.91671V8.75004C7.33366 8.98016 7.14711 9.16671 6.91699 9.16671C6.68687 9.16671 6.50033 8.98016 6.50033 8.75004V7.91671C6.50033 7.22635 5.94068 6.66671 5.25033 6.66671H2.75033Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCustomer);
export default __webpack_public_path__ + "static/media/add-customer.232d6f93b1de23aedd57a57463e6940c.svg";
export { ForwardRef as ReactComponent };